import React from 'react';
import PropTypes from 'prop-types';

import useIsContactFavorite from '@hooks/useIsContactFavorite';
import MemberListItemRedesign from './MemberListItemRedesign'; // eslint-disable-line

const MemberListItemRedesignWrapper = props => {
    const { graphID } = props;
    const isFavorite = useIsContactFavorite(graphID);

    if (typeof isFavorite === 'undefined') return null;

    return <MemberListItemRedesign {...props} isFavorite={isFavorite} />;
};

MemberListItemRedesignWrapper.propTypes = {
    graphID: PropTypes.string,
};

export default MemberListItemRedesignWrapper;
